/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Feeds_Updatedtoast1Inputs */

const en_common_feeds_updatedtoast1 = /** @type {(inputs: Common_Feeds_Updatedtoast1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feeds updated!`)
};

/**
* | output |
* | --- |
* | "Feeds updated!" |
*
* @param {Common_Feeds_Updatedtoast1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_feeds_updatedtoast1 = /** @type {((inputs?: Common_Feeds_Updatedtoast1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Feeds_Updatedtoast1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_feeds_updatedtoast1(inputs)
});
export { common_feeds_updatedtoast1 as "common.feeds.updatedToast" }